import React from 'react';
import './Toggle.css';

const Toggle = ({
  name,
  checked,
  onChange,
  label,
  disabled = false,
  size = 'medium'
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: e.target.checked,
          type: 'checkbox',
          checked: e.target.checked
        }
      });
    }
  };

  return (
    <label className={`toggle toggle-${size} ${disabled ? 'disabled' : ''}`}>
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <span className="toggle-slider"></span>
      {label && <span className="toggle-label">{label}</span>}
    </label>
  );
};

export default Toggle;
